export enum Roles {
    COMPANY_ADMIN = 'company-admin',
    COMPANY_USER = 'company-user',
    PHOTOGRAPHER = 'photographer',
}
